<template>
  <div class="comment-info-container">
    <InfoContainer
      :infoTitle="InfoContainerConfig['infoTitle']"
      :contentConfig="InfoContainerConfig['infoContent']"
    >
      <template :slot="InfoContainerConfig['infoContent'][0]['prop']">
        <div class="time-line-content" v-if="commentList.length > 0">
          <el-timeline>
            <template v-for="(item, i) in commentList">
              <el-timeline-item v-if="!item.isEdit" :key="i" :timestamp="item.time" placement="top">
                <template v-for="(comment, num) in item.comments">
                  <!-- 若为当前经办人， 显示评论框 -->
                  <el-card class="time-stamp" shadow="hover" :key="num">
                    <div class="title-line">
                      <div class="title-line-left">
                        <div class="comment-name">{{comment.assigneeName}} <span class="assignee-dept">{{comment.historyActivityName}}</span></div>
                        <!-- <span class="comment-position">{{comment.job}}</span> -->
                      </div>
                      <div class="title-line-right">
                        {{comment.comments[0].time}}
                        <i
                          style="cursor: pointer; padding-left: 10px;"
                          class="el-icon-close"
                          v-if="comment.assignee === userInfo.user_id"
                          @click="delFile(comment.comments[0].id, num, i)"
                        ></i>
                      </div>
                    </div>
                    <div class="time-stamp-content content-first" v-if="comment.attachments.length>0">{{comment.attachments[0].description}}</div>
                    <div class="time-stamp-content content-first" v-else>{{comment.comments[0].message}}</div>

                    <!-- 附件 -->
                    <div class="file-upload" v-if="comment.attachments.length>0">
                      <div class="file-container">
                        <div class="left-title">附件：</div>
                      </div>
                      <div class="right-content">
                        <template v-for="items in comment.attachments">
                          <div style="display: flex; align-items: center;" :key="`${items.id}${items.time}`">
                            <a style="margin-right: 15px;" target="_blank" :href="items.url">{{items.name}}</a>
                          </div>
                        </template>
                      </div>
                      <!-- <a :href="comment.attachments[0].url">附件：{{comment.attachments[0].name}}</a> -->
                    </div>

                  </el-card>
                </template>
              </el-timeline-item>

              <el-timeline-item
                v-else-if="item.isEdit && status == 'todo'"
                :key="i"
                :timestamp="item.time"
                placement="top"
              >
                <CommentBlock
                  ref="commentBlock"
                  :showTime="false"
                  :id="id"
                  :taskSaveData="taskSaveData"
                  :taskNo="taskNo"
                  @fileChange="fileChange"
                />
              </el-timeline-item>
            </template>
          </el-timeline>
        </div>

        <div class="time-line-content" v-else>
          暂无数据 
        </div>
      </template>
    </InfoContainer>
  </div>
</template>
<script>
import InfoContainer from "@/components/infoContainer/infoContainer";
import WordUpload from "@/components/wordUpload/wordUpload"
import CommentBlock from "@/components/workflowComponents/commentBlock/commentBlock";
import { downLoadTemplate } from "@/router/downLoadTem"
import * as dictionaries from "@/api/zd/dictionaries"
import { deleteFile } from "@/api/workFlow/workFlow"
import { mapGetters } from "vuex";
export default {
  name: 'CommentStep',
  data() {
    return {
      id: '',
      opinionId: '',
      files: [],
      attchmentList: [],
      opinionContent: '',
      InfoContainerConfig: {
        infoTitle: '会签意见区',
        infoContent: [{
          title: '',
          prop: 'basicInfo'
        }]
      }
    }
  },
  components: {
    InfoContainer,
    WordUpload,
    CommentBlock
  },  
  props: {
    commentList: {
      type: Array,
      default: ()=> {
        return []
      }
    },
    // done 或 todo
    status: {
      type: String,
      default: 'done'
    },
    taskNo: {
      type: Number,
      default: 0
    },
    // 保存的数据
    taskSaveData: {
      type: Object,
      default: ()=> {
        return {
          comment: '',
          attachment: []
        }
      }
    }
  },
  computed: {
    ...mapGetters(["userInfo"])
  },
  created() {
    this.id = this.$route.params.id
  },
  methods: {
    fileChange(fileList) {
      let self = this
      if(fileList.length > 0) {
        this.attchmentList = []
        fileList.map(item => {
          self.attchmentList.push({
            name: item.name,
            url: item.response.data.link
          })
        })
      }
    },

    showFileNames(data) {
      this.files = data
    },

    downLoadFile(id) {
      downLoadTemplate("/api/file/down", {
        id,
      }).finally(() => {
        this.loading = false;
        this.$message({
          type: "success",
          message: "已下载",
        });
      });
    },

       //删除附件
    delFile(fileId, num, i) {
      this.$confirm("确定将附件删除?", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
      .then(() => {
        deleteFile({commentId: fileId}).then(res => {
          this.commentList[i].comments.splice(num, 1)
          // this.formData['files'].splice(index, 1);
          this.$message({
            type: "success",
            message: "操作成功!",
          });
        })
      })
      .catch(() => {

      });
    }
  }
}
</script>
<style lang="scss" scoped>
.comment-info-container{
  .time-stamp{
    margin-bottom: 10px;
    .title-line{
      display: flex;
      justify-content: space-between;
      align-items: flex-end;
      .title-line-left{
        display: flex;
        justify-content: flex-start;
        align-items: flex-end;
        .comment-name{
          font-size: 14px;
          font-weight: 400;
          color: #666666;
          padding-right: 5px;
          .assignee-dept{
            color: #999;
            font-size: 12px;
          }
        }
        .comment-position{
          font-weight: 400;
          font-size: 12px;
          color: #999999;
        }
      }
      .title-line-right{
        font-weight: 400;
        font-style: normal;
        font-size: 12px;
        color: #999999;
      }
    }
    .time-stamp-content{
      color: #333;
      font-weight: 400;
      font-style: normal;
      font-size: 12px;
      text-align: left;
      line-height: 20px;
      .comment-tip{
        color:#3379CC;
      }
    }
    .content-first{
      margin-top: 8px;
    }
    .file-upload{
      margin-top: 5px;
      display: flex;
      justify-content: flex-start;
      align-content: center;
      .left-title{
        width: 40px;
        color: #333;
        font-weight: 400;
        font-style: normal;
        font-size: 12px;        
      }
      .right-content{
        flex: 1;
      }
      a{
        color: #333;
        font-weight: 400;
        font-style: normal;
        font-size: 12px;
      }
      a:hover{
        color: #409EFF;
      }
    }
    .timeline-title{
      font-weight: 400;
      font-size: 14px;
      line-height: 32px;
    }
    .opinion-content{
      margin-bottom: 10px;
    }
  }
}
</style>